import { ReactNode } from 'react';
import './FlipComponent.scss';
interface FlipCardI {
	frontContent: ReactNode;
	backContent: ReactNode;
	width?: string;
	height?: string;
	className?: string;
	onFlip?: (isFlipped: boolean) => void;
}
export const FlipComponent: React.FC<FlipCardI> = ({
	frontContent,
	backContent,
	className,
	onFlip,
	height = '300px',
	width = '200px'
}) => {
	// const [isFlipped, setIsFlipped] = useState<boolean>(false);
	// const handleFlip = () => {
	// 	const newFlippedState = !isFlipped;
	// 	setIsFlipped(newFlippedState);
	// 	if (onFlip) {
	// 		onFlip(newFlippedState);
	// 	}
	// };
	return (
		<div
			className={`flip-card-container`}
			// style={{ width, height }}
			// onClick={handleFlip}
		>
			<div className={`flip-card`}>
				<div className='flip-card-front'>{frontContent}</div>
				<div className='flip-card-back-revise'>{backContent}</div>
			</div>
		</div>
	);
};
